(function () {
    'use strict';
    var m = angular.module('troubleshooting');
    m.controller('InlineDebugController', ["$scope", "$q", "troubleshooting", "routeHelper", "$routeParams", "tablePaginationHelper", "inlinePolicyDao", "defaultListConverter", "modals", "troubleshootDao", "modulesDao", function ($scope, $q, troubleshooting, routeHelper, $routeParams, tablePaginationHelper, inlinePolicyDao, defaultListConverter, modals, troubleshootDao, modulesDao) {
        if (!troubleshooting.entityDebugEnabled()) {
            routeHelper.redirectTo('dashboard');
            return;
        }
        $scope.module = $routeParams.module;
        if ($scope.module !== 'office365_emails') {
            routeHelper.redirectTo('dashboard');
            return;
        }
        $scope.statusPanel = {
            title: 'Status',
            'class': 'light white-body white-header',
            size: 'medium'
        };
        $scope.tablePanel = {
            title: 'Excluded users',
            'class': 'light white-body white-header'
        };
        $scope.options = {
            'options': {
                'checkboxes': true,
                'singleSelection': false,
                'forceServerProcessing': false,
                'autoUpdate': 30000
            },
            'columns': [{
                    'id': 'email',
                    'text': 'Email',
                    'primary': true,
                    'sortable': true
                }]
        };
        function saveExcluded(excluded) {
            return modulesDao.saveConfig($scope.module, { excluded_from_inline: excluded.join(',') }, true);
        }
        $scope.tableOptions = {
            pagesAround: 2,
            pageSize: 1000000,
            showWorkingIndicator: true,
            workingIndicatorDisableGui: true,
            pagination: {
                page: 1,
                ordering: {},
                filter: ''
            },
            actions: [
                {
                    label: 'Delete',
                    display: 'button',
                    active: function () {
                        return $scope.tableHelper.getSelected().length;
                    },
                    execute: function () {
                        var selected = $scope.tableHelper.getSelectedIds();
                        return modals.confirm({ message: 'Are you sure you want to remove selected email' + (selected.length > 1 ? 's' : '') + ' from excluded list' + '<div class="paddingLR-sm">' + selected.join('<br>') + '</div>' }).then(function () {
                            return saveExcluded(_($scope.excluded).difference(selected));
                        }).then(function () {
                            $scope.tableHelper.clearSelection();
                            $scope.tableHelper.reload();
                        });
                    }
                },
                {
                    label: 'Add excluded email',
                    display: 'button',
                    execute: function () {
                        modals.params([{
                                params: [{
                                        type: 'list',
                                        label: 'Emails to exclude',
                                        id: 'emails',
                                        validation: { required: true },
                                        settings: {
                                            tokenSeparators: [
                                                ',',
                                                ' ',
                                                '\t',
                                                '\n'
                                            ]
                                        }
                                    }],
                                lastPage: true
                            }], 'Add emails to exclude').then(function (data) {
                            var excluded = _(data.emails).chain().map(function (email) {
                                return $.trim(email.toLowerCase());
                            }).union($scope.excluded).sortBy().value();
                            return saveExcluded(excluded);
                        }).then(function () {
                            $scope.tableHelper.reload();
                        });
                    }
                }
            ]
        };
        $scope.toggleEmergency = function () {
            var action = $scope.emergency ? 'Disable' : 'Enable';
            modals.confirm({
                title: action + ' emergency stop',
                message: 'Are you sure you want to <span class="emergency-confirm-action">' + action + '</span> inline emergency stop for ' + $scope.module + '?',
                okText: action
            }).then(function () {
                return troubleshootDao.inlineSwitch($scope.module);
            }).then(function () {
                $scope.tableHelper.reload();
            });
        };
        $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
            return inlinePolicyDao.retrieveConfig($scope.module).converter(function (input) {
                $scope.emergency = input.data.emergency;
                $scope.excluded = _(input.data.excluded && input.data.excluded.split && input.data.excluded.split(',') || []).map(function (email) {
                    return $.trim(email.toLowerCase());
                });
                return $q.when({
                    data: {
                        rows: _($scope.excluded).map(function (email) {
                            return { email: email };
                        })
                    }
                });
            }).converter(defaultListConverter, { columns: $scope.options.columns });
        }, function (tableModel) {
            $scope.tableModel = tableModel;
            $scope.tablePanel.title = $scope.tableHelper.getTotal() + ' Excluded Users';
        });
    }]);
}());